// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"Spinner_spinnerWrapper__fD2+T","spinner":"Spinner_spinner__VLMsb","spin":"Spinner_spin__kZIhE"};